export const programId = '5ec6ca9b10b37d1afcf7c1d5';

export const defaultOptions = {
    restApi: {
        serviceUrl: 'https://services.sheerid.com/',
    },

    logLevel: 'error',
    useFingerprinting: true,
};
